import { memo, useMemo } from 'react'
import { Table, Space, Popconfirm } from 'antd'
import type { ColumnsType } from 'antd/es/table'
import { TrainingField } from 'types/fields'
import { tableValueFromBoolean } from '../../utils'
import { modalTitle as formatModalTitle } from 'utils/modal-title'

type Props = {
    data: TrainingField[]
    onEdit: (id: number) => void
    onDelete: (id: number) => void
    loading: boolean
}

export const TrainingFieldsTable = memo((props: Props) => {
    const { data, onEdit, onDelete, loading } = props

    const columns: ColumnsType<TrainingField> = useMemo(
        () => [
            {
                title: 'ID',
                dataIndex: 'id',
                key: 'id',
            },
            {
                title: 'Name',
                dataIndex: 'name',
                key: 'name',
            },
            {
                title: 'Dressing room',
                dataIndex: 'dressingRoom',
                key: 'dressingRoom',
                render: (_, record) => tableValueFromBoolean(record.dressingRoom),
            },
            {
                title: 'Shower',
                dataIndex: 'shower',
                key: 'shower',
                render: (_, record) => tableValueFromBoolean(record.shower),
            },
            {
                title: 'Camera',
                dataIndex: 'camera',
                key: 'camera',
                render: (_, record) => tableValueFromBoolean(record.camera),
            },
            {
                title: 'Price',
                dataIndex: 'price',
                key: 'price',
            },
            {
                title: 'Action',
                key: 'action',
                render: (_, record) => (
                    <Space size='middle'>
                        <a onClick={() => onEdit(record.id)}>Edit</a>
                        <Popconfirm
                            title={formatModalTitle('Delete training field', record.name)}
                            description={'Are you sure to delete this field?'}
                            onConfirm={() => onDelete(record.id)}
                            okText={'Yes'}
                            cancelText={'No'}
                        >
                            <a href='#'>Delete</a>
                        </Popconfirm>
                    </Space>
                ),
            },
        ],
        [onDelete, onEdit]
    )

    return <Table loading={loading} columns={columns} dataSource={data} rowKey='id' pagination={false} />
})
